import { useTranslation } from 'react-i18next'
import { DateFilterEnum } from '@/enums/date-filter-type.enum'
import { MenuItem, TextField, Box, SxProps } from '@mui/material'

import { KeyboardArrowDown } from '@mui/icons-material'
import { menuProps } from '@/constants/mui'
import { DateRangePickerComponent } from '../date-range-picker'

type DateOptionType = {
  name: string
  value: DateFilterEnum
}

type Props = {
  date: DateFilterEnum
  startDate: Date | null
  endDate: Date | null
  dateOptions?: DateOptionType[]
  sx?: SxProps
  onChangeStartDate: (date: Date | null) => void
  onChangeEndDate: (date: Date | null) => void
  handleChangeDate: (date: DateFilterEnum) => void
}

export const DatePeriodPickerComponent = ({
  date,
  startDate,
  endDate,
  dateOptions,
  sx,
  onChangeStartDate,
  onChangeEndDate,
  handleChangeDate,
}: Props) => {
  const { t } = useTranslation()

  const filterOptions = dateOptions || [
    {
      name: t('labels.lifetime'),
      value: DateFilterEnum.LIFETIME,
    },
    {
      name: t('labels.today'),
      value: DateFilterEnum.TODAY,
    },
    {
      name: t('labels.last7Days'),
      value: DateFilterEnum.LAST_7_DAYS,
    },
    {
      name: t('labels.last30Days'),
      value: DateFilterEnum.LAST_30_DAYS,
    },
    {
      name: t('labels.dateRange'),
      value: DateFilterEnum.DATE_RANGE,
    },
  ]

  return (
    <Box display="flex" gap={1} minWidth="100%" sx={{ ...sx }}>
      <TextField
        label={t('labels.date')}
        select
        fullWidth
        value={date || ''}
        onChange={(event) =>
          handleChangeDate(event.target.value as DateFilterEnum)
        }
        margin="normal"
        size="small"
        variant="outlined"
        SelectProps={{
          IconComponent: KeyboardArrowDown,
          MenuProps: menuProps,
        }}
        sx={{ marginTop: '8px' }}
      >
        {filterOptions.map((option) => (
          <MenuItem key={option.name} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
      {date === DateFilterEnum.DATE_RANGE && (
        <Box minWidth={285}>
          <DateRangePickerComponent
            startDate={startDate}
            endDate={endDate}
            onChangeStartDate={onChangeStartDate}
            onChangeEndDate={onChangeEndDate}
          />
        </Box>
      )}
    </Box>
  )
}
